import React from "react"
import {Language} from "react-checkbox-tree"
import {toastr} from "react-redux-toastr"
import {Header} from "semantic-ui-react"
import {$myFetch} from "."
import {
    IRawSupplierReference,
    IReferenceIds,
    ISupplierReference,
    ITranslations,
} from "../../models"
import {Multilang} from "../../models/product/multilang-string"
import {IProductRefVente} from "../../models/product/productRefVente"
import {Languages, Roles} from "../../utils"
import {responseType, transform} from "../../utils/http-res-handler"
import {$validateProduct} from "./req_product-form"

export const $getRawProductList = (
    role: Roles,
    translations: any
): Promise<IRawSupplierReference[]> => {
    const myHeaders = new Headers()
    return $myFetch(
        "product",
        {
            headers: myHeaders,
        },
        [],
        role
    )
        .then((res) => transform(res, translations, responseType.json))
        .then((res: IRawSupplierReference[]) =>
            res.map((product) => ({
                ...product,
                label: Multilang.String.CreateFrom(product.label),
            }))
        )
}

export const $deleteProducts = (
    ids: string[],
    role: Roles
): Promise<Response[]> => {
    const myHeaders = new Headers()
    const promises = ids.map((id) => {
        return $myFetch(
            "product/" + id,
            {
                headers: myHeaders,
                method: "DELETE",
            },
            [],
            role
        )
    })

    return Promise.all(promises)
}

export const $setProductIsDelete = (
    ids: IReferenceIds[],
    isDelete: boolean,
    role: Roles,
    supplierName: string
): Promise<Response> => {
    const myHeaders = new Headers()
    myHeaders.append("Content-Type", "application/json")

    return $myFetch(
        "product/setDelete",
        {
            body: JSON.stringify({
                droopyIds: ids
                    .filter((x) => !x.topDroopyId)
                    .filter(
                        (x) =>
                            !x.isTopRef ||
                            (x.isTopRef && ids.some((n) => n.topDroopyId === x.droopyId))
                    )
                    .map((o) => o.droopyId),
                declined: ids
                    .filter((x) => x.topDroopyId)
                    .map((o) => ({droopyId: o.droopyId, topDroopyId: o.topDroopyId})),
                delete: isDelete,
            }),
            headers: myHeaders,
            method: "POST",
        },
        [],
        role,
        supplierName
    ).then((res: Response) => res)
}

export const $getProductRefVentes = (
    idSocieteg: string,
    role: Roles
): Promise<IProductRefVente[]> => {
    const myHeaders = new Headers()
    myHeaders.append("Content-Type", "application/json")

    return $myFetch(
        "product/refVentes",
        {
            headers: myHeaders,
        },
        [{key: "idSocieteg", value: idSocieteg}],
        role
    ).then((res) => {
        return res.json()
    })
}

export const $activateProducts = (
    supplierRefs: string[],
    declinedSupplierRefs: string[],
    activate: boolean,
    role: Roles
): Promise<Response> => {
    const myHeaders = new Headers()
    myHeaders.append("Content-Type", "application/json")
    return $myFetch(
        "product/activateBySupplierRefs",
        {
            body: JSON.stringify({
                supplierRefs,
                declinedSupplierRefs,
                value: activate,
            }),
            headers: myHeaders,
            method: "POST",
        },
        [],
        role
    )
}

export const $getValidationHistory = (
    supplierName: string,
    supplierRef: string
): Promise<{ username: string; date: string }[]> => {
    const myHeaders = new Headers()
    myHeaders.append("Content-Type", "application/json")

    return $myFetch("product/validationHistory", {
        headers: myHeaders,
    }, [
        {key: "supplierName", value: supplierName},
        {key: "supplierRef", value: supplierRef},
    ]).then((res) => res.json())
}

export const $validateProducts = (
    supplierRefs: string[],
    declinedSupplierRefs: string[],
    role: Roles,
    supplierName: string,
    translations: ITranslations["productList"]
): Promise<Response> => {
    const myHeaders = new Headers()
    myHeaders.append("Content-Type", "application/json")
    toastr.message(translations.longRequestToastrHeader, "", {
        component: (
            <>
                <p>{translations.longRequestToastrBodyOne}</p>
                <p>{translations.longRequestToastrBodyTwo}</p>
            </>
        ),
    })
    return $myFetch(
        "product/validateBySupplierRefs",
        {
            body: JSON.stringify({supplierRefs, declinedSupplierRefs}),
            headers: myHeaders,
            method: "POST",
        },
        [],
        role,
        supplierName
    ).then((res) => {
        toastr.removeByType("message")
        toastr.info(translations.longRequestToastrSuccess, "", {
            showCloseButton: true,
            timeOut: 25000,
        })
        return res
    }).catch((err) => {
        // The error itself is displayed by $myFetch.
        toastr.removeByType("message")
        throw err
    })
}
